<table
    class="w-full bg-transparent mb-10"
    mat-table
    matSort
    [dataSource]="dataSourseGestiones"
    #gestiones>
    <!-- formulario ID -->
    <ng-container matColumnDef="form-id">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
            Formulario
        </th>
        <td mat-cell *matCellDef="let gestion">
            <form-type-widget [clasificacion]="gestion.clasificacion"></form-type-widget>
        </td>
    </ng-container>

    <!-- Gestión -->
    <ng-container matColumnDef="gestion">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
            Gestión
        </th>
        <td mat-cell *matCellDef="let gestion">
            <span class="whitespace-nowrap pr-6 text-sm">
                {{ gestion?.nombreTarea }}
            </span>
        </td>
    </ng-container>

    <!-- Estado -->
    <ng-container matColumnDef="estado">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
            Estado
        </th>
        <td mat-cell *matCellDef="let gestion">
            <status-sticker [estado]="gestion.estadoTarea?.descripcion" [color1]="gestion.estadoTarea?.valor1" [color2]="gestion.estadoTarea?.valor2"></status-sticker>
        </td>
    </ng-container>

    <!-- Solicitante -->
    <ng-container matColumnDef="solicitante">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
            Solicitante
        </th>
        <td mat-cell *matCellDef="let gestion">
           <span class="whitespace-nowrap pr-6 text-sm">
                {{ gestion?.solicitante }}
            </span>
        </td>
    </ng-container>

    <!-- Origen-->
    <ng-container matColumnDef="origen">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 text-nowrap">
            Origen
        </th>
        <td mat-cell *matCellDef="let gestion">
            <span class="whitespace-nowrap text-sm">
                {{gestion.origen.descripcion }}
            </span>
        </td>
    </ng-container>

    <!-- Usuarios asignados-->
    <ng-container matColumnDef="usuariosAsignados">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 text-nowrap">
            Usuarios Asignados
        </th>
        <td mat-cell *matCellDef="let gestion">
            <div  class="flex gap-1">
                <ng-container *ngFor="let usuario of gestion.usuariosAsignados; let i = index">
                    <user-avatar-name [name]="usuario.nombreCompleto"></user-avatar-name>
                </ng-container>
            </div>
        </td>
    </ng-container>

    <!--  Fecha de ingreso de la gestión -->
    <ng-container matColumnDef="fecha-ingreso">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 text-nowrap">
            Fecha de Ingreso
        </th>
        <td mat-cell *matCellDef="let gestion">
            <span class="whitespace-nowrap text-sm">
                {{ gestion?.fechaIngreso  | date: 'mediumDate' }}
            </span>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="gestionesTableColumns"></tr>
    <tr class="order-row h-10 border-y border-gray-200 cursor-pointer hover:font-semibold" 
        (click)="openTaskDetails(row.tareaUuid)"
    mat-row *matRowDef="let row; columns: gestionesTableColumns;"></tr>
</table>